import { Heading, Text } from "@medusajs/ui"
import { Link, useLocation } from "react-router-dom"
import { SETTINGS_NAV } from "@/lib/settings-nav"
import { PageHeader, Section } from "@/components/ui"

/** Placeholder for areas on the roadmap, so navigation and permissions can be wired now. */
export function ComingSoon({ title, body }: { title: string; body: string }) {
  return (
    <>
      <PageHeader title={title} />
      <Section>
        <div className="flex flex-col gap-y-2 px-4 py-10">
          <Heading level="h2">Coming next</Heading>
          <Text size="small" className="max-w-xl text-ui-fg-subtle">
            {body}
          </Text>
        </div>
      </Section>
    </>
  )
}

export function NotFound() {
  return (
    <div className="flex flex-col items-center gap-y-2 py-24 text-center">
      <Heading>Page not found</Heading>
      <Link to="/" className="txt-compact-small-plus text-ui-fg-interactive">
        Go home
      </Link>
    </div>
  )
}

/** A settings page that isn't built yet: same frame as Shopify's, with what it will hold. */
export function SettingsComingSoon() {
  const { pathname } = useLocation()
  const item = SETTINGS_NAV.find((i) => pathname.startsWith(i.to))
  return (
    <>
      <h1 className="k-h1 mb-6">{item?.label ?? "Settings"}</h1>
      <Section>
        <div className="flex flex-col gap-y-2 px-5 py-8">
          <Heading level="h2">Coming next</Heading>
          <Text size="small" className="max-w-xl text-ui-fg-subtle">
            {item?.body ?? "This setting is on the roadmap."}
          </Text>
        </div>
      </Section>
    </>
  )
}
